import React, { cloneElement, useEffect, useState } from 'react';
import { array, func, number, object, string, any, oneOfType } from 'prop-types';

const Tabs = ({ onClick, children, defaultActive = '', style: overwriteStyle, ...restProps }) => {
  const [active, setActive] = useState(defaultActive);

  useEffect(() => {
    if (defaultActive) {
      setActive(defaultActive);
    }
  }, [defaultActive]);

  const onItemClick = (value) => {
    setActive(value);
    onClick(value);
  };

  return (
    <ul role="tablist" style={{ ...styles.list, ...overwriteStyle }} {...restProps}>
      {children.map((child, i) =>
        cloneElement(child, {
          key: i,
          onClick: onItemClick,
          active: active === child.props.value,
        }),
      )}
    </ul>
  );
};

const styles = {
  list: {
    display: 'flex',
    alignItems: 'baseline',
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
};

Tabs.propTypes = {
  onClick: func.isRequired,
  children: array.isRequired,
  defaultActive: oneOfType([string, number]),
  style: object,
  restProps: any,
};

export default Tabs;
